import {
  BUSINESS_TYPE_LIMITED_COMPANY,
  BUSINESS_TYPE_LIMITED_LIABILITY_PARTNERSHIP,
  BUSINESS_TYPE_NOT_SURE,
  BUSINESS_TYPE_PARTNERSHIP,
  BUSINESS_TYPE_SOLE_TRADER,
  BUSINESS_TYPE_TRADING_TRUST,
  COMPANY_HELD,
  PERSONALLY_HELD,
  TRUST_HELD
} from "../constants/appConstants";

const COUNTRY_CODES = ["NZ", "AU"];
export const countries = [
  { id: 0, name: "All", value: "" },
  ...COUNTRY_CODES.map((code, index) => ({
    id: index + 1,
    name: code,
    value: code
  }))
];
const ORG_NAMES = [
  { name: "---Choose---", value: "" },
  { name: "Company", value: "company" },
  { name: "Sole Trader", value: "soletrader" },
  { name: "Partnership", value: "partnership" },
  { name: "Limited Partnership", value: "limitedpartnership" },
  { name: "Trust", value: "trust" }
];
export const org_types = [
  ...ORG_NAMES.map(({ name, value }) => ({
    name,
    value
  }))
];
export const system_control = [
  {
    name: "No",
    value: "false"
  },
  {
    name: "Yes",
    value: "true"
  }
];

const USER_TYPE_DEFINITIONS = [
  { name: "All", value: "" },
  { name: "Customer", value: "regular" },
  { name: "Conference Customer", value: "conference" }
];
export const user_types = USER_TYPE_DEFINITIONS.map((item, index) => ({
  id: index + 1,
  ...item
}));

const STATUS_MAP = {
  ALL: { name: "All", value: "" },
  PENDING: { name: "Pending", value: 1 },
  APPROVED: { name: "Approved", value: 2 },
  ACTIVE: { name: "Approved – Active", value: 18 },
  INACTIVE: { name: "Approved – Inactive", value: 19 },
  NOT_APPROVED: { name: "Not Approved", value: 3 },
  ARCHIVED: { name: "Archived", value: 7 }
};
export const status_short = Object.values(STATUS_MAP);

const STATUS_UPDATE_OPTIONS = [
  ["Choose new status", ""],
  ["Pending", 1],
  ["Approved", 2],
  ["Not Approved", 3],
  ["Archived", 7],
  ["Pre Approved", 9],
  ["Test Account", 12],
  ["Customer DD", 13]
];
export const status_update = STATUS_UPDATE_OPTIONS.map(
  ([name, value], index) => ({
    id: index,
    name,
    value
  })
);

export const account_type = [
  {
    name: "Full",
    value: "full"
  },
  {
    name: "Demo",
    value: "demo"
  }
];

export const direct_debit = [
  {
    id: 1,
    name: "Active",
    value: "true"
  },
  {
    id: 2,
    name: "Inactive",
    value: "false"
  }
];
const TIME_PERIOD_DEFINITIONS = [
  { name: "Month", value: "month" },
  { name: "3 Months", value: "quarter" },
  { name: "6 Months", value: "half_year" },
  { name: "Annual", value: "year" },
  { name: "Financial Year", value: "financial_year" }
];

export const time_priod = TIME_PERIOD_DEFINITIONS.map((item, index) => ({
  id: String(index + 1),
  ...item
}));
const REPORT_DEFINITIONS = [
  { name: "Profit & Loss", value: "profitLoss" },
  { name: "Balance Sheet", value: "balancesheet" },
  { name: "Executive Summary", value: "executiveSummary" },
  { name: "Accounts Payable", value: "accountspayable" },
  { name: "Accounts Receivable", value: "accountsreceivable" },
  { name: "Bank Summary", value: "banksummary" },
  { name: "Bank Transactions", value: "banktransactions" }
];
export const reports = REPORT_DEFINITIONS.map((item, index) => ({
  id: String(index + 1),
  ...item
}));

export const payment_status = [
  {
    id: 1,
    name: "FT ENTERED - Pending",
    value: "FT ENTERED - Pending"
  },
  {
    id: 2,
    name: "FT ENTERED - Paid",
    value: "FT ENTERED - Paid"
  },
  {
    id: 3,
    name: "FT ENTERED - Failed",
    value: "FT ENTERED - Failed"
  }
];

export const agreement = {
  common: [{ name: "Choose..", value: "", disable: false }],
  nz: [
    {
      name: "Finish Application",
      value: "FINISH_APPLICATION",
      disable: false,
      showPrimaryUserValue: true
    },
    {
      name: "──────────────────────",
      value: "",
      disable: true,
      showPrimaryUserValue: true
    },
    { name: "ID & FT Agreement", value: "ID_AND_FT_AGREEMENT", disable: false },
    { name: "ID & Guarantee", value: "ID_AND_GUARANTEE", disable: false },
    { name: "ID only", value: "id_only", disable: false },
    { name: "──────────────────────", value: "", disable: true },
    { name: "FT Agreement (no ID)", value: "Agreement", disable: false },
    { name: "Guarantee (no ID)", value: "Guarantee", disable: false },
    {
      name: "──────────────────────",
      value: "",
      disable: true,
      showPrimaryUserValue: true
    },
    {
      name: "Directors Resolution",
      value: "Directors_Resolution",
      disable: false,
      showPrimaryUserValue: true
    },
    {
      name: "──────────────────────",
      value: "",
      disable: true,
      showPrimaryUserValue: true
    },
    {
      name: "Demand Letters",
      value: "DEMAND_LETTERS",
      disable: false,
      showPrimaryUserValue: true
    }
    /* {
      name: "──────────────────────",
      value: "",
      disable: true,
      showPrimaryUserValue: true
    },
    {
      name: "Link Acc. Soft. & Bank accounts",
      value: "LINK_ACC_SOFTWARE_AND_BANK",
      disable: false,
      showPrimaryUserValue: true
    },
    {
      name: "Direct Debit Mandate",
      value: "DIRECT_DEBIT_MANDATE",
      disable: false,
      showPrimaryUserValue: true
    },
    {
      name: "Other Owners",
      value: "OTHER_OWNERS",
      disable: false,
      showPrimaryUserValue: true
    },
    {
      name: "──────────────────────",
      value: "",
      disable: true,
      showPrimaryUserValue: true
    } */
  ],
  au: [
    {
      name: "Finish Application",
      value: "FINISH_APPLICATION",
      disable: false,
      showPrimaryUserValue: true
    },
    { name: "──────────────────────", value: "", disable: true },
    { name: "ID & FT Agreement", value: "ID_AND_FT_AGREEMENT", disable: false },
    { name: "ID & Guarantee", value: "ID_AND_GUARANTEE", disable: false },
    { name: "ID only", value: "id_only", disable: false },
    { name: "──────────────────────", value: "", disable: true },
    { name: "FT Agreement (no ID)", value: "Agreement", disable: false },
    { name: "Guarantee (no ID)", value: "Guarantee", disable: false },
    {
      name: "──────────────────────",
      value: "",
      disable: true,
      showPrimaryUserValue: true
    },
    {
      name: "Directors Resolution",
      value: "Directors_Resolution",
      disable: false,
      showPrimaryUserValue: true
    },
    {
      name: "──────────────────────",
      value: "",
      disable: true,
      showPrimaryUserValue: true
    },
    {
      name: "Demand Letters",
      value: "DEMAND_LETTERS",
      disable: false,
      showPrimaryUserValue: true
    }
    /* {
      name: "──────────────────────",
      value: "",
      disable: true,
      showPrimaryUserValue: true
    },
    {
      name: "Link Acc. Soft. & Bank accounts",
      value: "LINK_ACC_SOFTWARE_AND_BANK",
      disable: false,
      showPrimaryUserValue: true
    },
    {
      name: "Direct Debit Mandate",
      value: "DIRECT_DEBIT_MANDATE",
      disable: false,
      showPrimaryUserValue: true
    },
    {
      name: "Other Owners",
      value: "OTHER_OWNERS",
      disable: false,
      showPrimaryUserValue: true
    } */
  ]
};

const OWNERSHIP_LIST = [
  { name: "Choose", value: "Choose" },
  { name: "Yes", value: "Yes" },
  { name: "No", value: "No" },
  {
    name: "No - but I own other property",
    value: "No-but I own other Property"
  }
];
export const pr_ownership = OWNERSHIP_LIST.map((item, index) => ({
  id: index + 1,
  ...item
}));
const TRUST_AGREEMENT_OPTIONS = [
  ["Choose", ""],
  ["FT Trust Guarantee", "Trust_Guarantee"],
  ["Trust Deed", "Trust_Deed"],
  ["Other (Specify)", "Other"]
];
export const trust_agreement = TRUST_AGREEMENT_OPTIONS.map(([name, value]) => ({
  name,
  value
}));

const CORPORATE_AGREEMENT_OPTIONS = [
  ["Choose", "Choose"],
  ["FT Corporate Guarantee", "Corporate_Guarantee"],
  ["Other (Specify)", "Other"]
];

export const corporate_agreement = CORPORATE_AGREEMENT_OPTIONS.map(
  ([name, value]) => ({ name, value })
);

export const select_question = [
  {
    id: 0,
    name: "COMPANY STRUCTURE",
    content:
      "Can you please confirm if you are operating as a sole trader or under a company structure? If you use a company structure can you please confirm the full legal name of your business entity?"
  },
  {
    id: 1,
    name: "FINANCIALS",
    content:
      "Do you have the 2023 end-of-year financials for your business that you could please send through? Alternatively, can you please export from your financial system your Profit and Loss, Balance Sheet, Accounts Receivable and Accounts Payable report?"
  },
  {
    id: 2,
    name: "GST",
    content:
      "The Balance Sheet shows GST owing of [gst]. Can you please confirm the current tax amounts owed by sending a screenshot from your ATO portal showing any current balances owed?"
  },
  {
    id: 3,
    name: "LOANS",
    content:
      "The Balance Sheet shows as of: [liabilities]. Can you please confirm the current value of these loans, what they relate to and the repayment obligations in place for them?"
  },
  {
    id: 4,
    name: "AR",
    content:
      "In the Accounts Receivable report it shows that of the [accounts_receivable] in invoices owed to your business, [accounts_receivable_60_plus] is 60+ days old. Can you please detail if this is correct? If so, can you please outline what the situation is and why these invoices have not yet been paid?"
  },
  {
    id: 5,
    name: "PROPERTY",
    content:
      "It looks as though the property ownership question was missed during sign-up. Can you please confirm if you own any property? Please note, that no mortgages or caveats are placed on the property during funding. This query allows the credit team to gain a better understanding of your overall financial situation."
  },
  {
    id: 6,
    name: "OVERVIEW",
    content:
      "Can you please provide an overview of your business model (what service/product you provide and the TOT)? Can you please also outline your current situation and need for FundTap (e.,g $x minimum to $x maximum)?"
  }
];

const CUSTOMER_MONTHLY_RANGE = [
  ["Specific Date Range", "specific_date_range"],
  ["This Month", "this_month"],
  ["Last Month", "last_month"],
  ["Last 3 months", "last_3_month"],
  ["Last 6 months", "last_6_month"],
  ["Last 12 months", "last_12_month"],
  ["Last 24 months", "last_24_month"],
  ["Last 36 months", "last_36_month"]
];
export const customer_monthly_report = CUSTOMER_MONTHLY_RANGE.map(
  ([name, value]) => ({
    name,
    value
  })
);
const MONTH_RANGES = ["2", "4", "6", "8", "10", "12", "36"];
export const comission_month_range = MONTH_RANGES.map((num) => ({
  number: num,
  value: num
}));

const MIN_FONT_SIZE = 10;
const MAX_FONT_SIZE = 34;
export const fontSize = Array.from(
  { length: MAX_FONT_SIZE - MIN_FONT_SIZE + 1 },
  (_, i) => {
    const size = `${MIN_FONT_SIZE + i}px`;
    return { value: size, label: size };
  }
);

const FONT_WEIGHTS = [
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900"
];
export const fontWeight = FONT_WEIGHTS.map((weight) => ({
  value: weight,
  label: weight
}));

const BUSINESS_ITEMS = [
  "FT credit score",
  "Credit Score",
  "GSAs",
  "PPSRs",
  "Time in Business",
  "Ownership:"
];
export const BusinessData = BUSINESS_ITEMS.map((business, index) => ({
  id: index + 1,
  business,
  numbers: "",
  details: "",
  blank: ""
}));
const FINANCIAL_ITEMS = [
  "Turnover",
  "Cash In",
  "Cash Out",
  "Gross Profit",
  "Profit",
  "AR",
  "AR 60+",
  "Debtor History",
  "AP",
  "AP 60+",
  "P & L inconsistencies",
  "Current Ratio",
  "GST",
  "Expected GST",
  "PAYE",
  "Wages, holiday pay and super",
  "Expected PAYE",
  "Liabilities",
  "Equity",
  "Balance Sheet inconsistencies"
];
export const FinancialsData = FINANCIAL_ITEMS.map((financials, index) => ({
  id: index + 1,
  financials,
  now_12m: "",
  m12_m24: "",
  m24_m36: ""
}));
const COUNTRY_ITEMS = [
  ["- Select Country -", ""],
  ["NZ", "NZ"],
  ["AU", "AU"]
];
export const Country = COUNTRY_ITEMS.map(([country_name, value], index) => ({
  id: index + 1,
  country_name,
  value
}));
const STATE_DEFINITIONS = [
  ["Select State", ""],
  ["ACT", "ACT"],
  ["NSW", "NSW"],
  ["NT", "NT"],
  ["QLD", "QLD"],
  ["SA", "SA"],
  ["TAS", "TAS"],
  ["VIC", "VIC"],
  ["WA", "WA"]
];
export const State = STATE_DEFINITIONS.map(([state_name, value], index) => ({
  id: index + 1,
  state_name,
  value
}));
export const Organisation_Lead = [
  {
    id: 1,
    lead_type: "Yes",
    value: "yes"
  },
  {
    id: 2,
    lead_type: "No",
    value: "no"
  }
];
const REFERRAL_TYPE_DEFINITIONS = [
  ["All", ""],
  ["Bookkeeper", "Bookkeeper"],
  ["Accountant", "Accountant"],
  ["Finance Brokers", "Broker"],
  ["Platform", "Platform"],
  ["Referrers", "Other"]
];

export const Referral_Type = REFERRAL_TYPE_DEFINITIONS.map(
  ([name, value], index) => ({
    id: index,
    name,
    value
  })
);
export const Upfront_type = [
  {
    id: 1,
    item: "% of credit limit",
    value: "% of credit limit"
  },
  {
    id: 2,
    item: "$ set bonus",
    value: "fixed bonus amount"
  },
  {
    id: 3,
    item: "% of fee",
    value: "% of fee"
  }
];

export const trail_type = [
  {
    id: 1,
    item: "% per year",
    value: "% per year"
  },
  {
    id: 2,
    item: "% of fee",
    value: "% of fee"
  }
];

export const discount_type = [
  {
    id: 1,
    item: "% of fee",
    value: "% of fee"
  },
  {
    id: 2,
    item: "$ set bonus",
    value: "fixed bonus amount"
  }
];
const TIME_PERIOD_VALUES = [
  ["Not Limited", ""],
  ["1", "1"],
  ["3", "3"],
  ["6", "6"],
  ["9", "9"],
  ["12", "12"],
  ["18", "18"],
  ["24", "24"],
  ["36", "36"],
  ["60", "60"]
];
export const time_period = TIME_PERIOD_VALUES.map(([time, value], index) => ({
  id: index + 1,
  time,
  value
}));

export const financialsCategoryMap = {
  TURNOVER: "Turnover",
  GROSS_PROFIT: "Gross Profit",
  PROFIT: "Profit",
  EXPECTED_GST: "Expected GST",
  CASH_INFLOW: "Cash In",
  CASH_OUTFLOW: "Cash Out",
  ACCOUNTS_RECEIVABLE: "AR",
  ACCOUNTS_RECEIVABLE_OVER_60_DAYS: "AR 60+",
  DEBTOR_HISTORY: "Debtor History",
  ACCOUNTS_PAYABLE: "AP",
  ACCOUNTS_PAYABLE_OVER_60_DAYS: "AP 60+",
  P_AND_L_INCONSISTENCIES: "P & L inconsistencies",
  CURRENT_RATIO: "Current Ratio",
  GST: "GST",
  PAYE: "PAYE",
  WAGES_HOLIDAY_PAY_AND_SUPER: "Wages, holiday pay and super",
  EXPECTED_PAYE: "Expected PAYE",
  TOTAL_LIABILITIES: "Liabilities",
  TOTAL_EQUITY: "Equity",
  BALANCE_SHEET_INCONSISTENCIES: "Balance Sheet inconsistencies"
};
const CUSTOMER_TIME_PERIOD_VALUES = [
  ["6 Months", "6"],
  ["1 Year", "12"],
  ["2 Years", "24"],
  ["3 Years", "36"],
  ["4 Years", "48"],
  ["5 Years", "60"],
  ["6 Years", "72"],
  ["7 Years", "84"],
  ["All Time", "all"]
];

export const customer_time_period = CUSTOMER_TIME_PERIOD_VALUES.map(
  ([name, value], index) => ({
    id: index + 1,
    name,
    value
  })
);
const VIEW_TYPES = [
  ["Month", "Month"],
  ["Quarter", "Quarter"],
  ["Year", "Year"]
];

export const viewType = VIEW_TYPES.map(([name, value], index) => ({
  id: index + 1,
  name,
  value
}));
export const overdueReportType = [
  {
    id: 1,
    name: "Completed",
    value: "completed"
  },
  {
    id: 2,
    name: "All Advanced",
    value: "allAdvanced"
  }
];

const OVERDUE_REPORT_DOWNLOAD_OPTIONS = [
  ["All", "all"],
  ["Trades/Construction", "Trades/Construction"],
  ["Consultants", "Consultants"],
  ["Recruitment", "Recruitment"],
  ["Distributors/Wholesalers", "Distributors/Wholesalers"],
  ["B2B Service Provider", "B2B Service Provider"],
  ["Other - (Must Specify)", "Other - (Must Specify)"]
];
export const overdueReportDownload = OVERDUE_REPORT_DOWNLOAD_OPTIONS.map(
  ([name, value], index) => ({
    id: index,
    name,
    value
  })
);

const MONTHLY_SALES_REPORT_FIELDS = [
  ["FundTap Quote Id", "FTQuoteID"],
  ["Status", "status"],
  ["Xero Status", "xeroStatus"],
  ["Invoice Number", "invoiceNumber"],
  ["Date Funded", "dateFunded"],
  ["Customer", "customer"],
  ["Debtor", "debtor"],
  ["Inv Funded", "invFunded"],
  ["Invoice Fee", "feeToday"],
  ["Amount Due", "amountDue"],
  ["Due Date", "dueDate"],
  ["Due In", "dueIn"],
  ["Date Completed", "dateCompleted"]
];
export const monthlySalesReportDetails = MONTHLY_SALES_REPORT_FIELDS.map(
  ([name, value], index) => ({
    id: index,
    name,
    value
  })
);
const INVOICE_TABLE_COLUMNS = [
  "FT No.",
  "Status",
  "Performance Score",
  "Approval Score",
  "Scheduled Status",
  "Repay Date",
  "Due Date",
  "Acc. Sys. Status",
  "Sent",
  "Invoice Number",
  "Date Funded",
  "Customer",
  "Debtor",
  "Inv Funded",
  "Quoted Fee",
  "Fee Today",
  "Fee",
  "Amount Due",
  "Due In",
  "Sum",
  "Alerts",
  "Comments",
  "Inv Amount (Owing)",
  "Acc Status",
  "Repay Fee",
  "Pricing",
  "Overdue Date",
  "Original Due Date",
  "Total Due",
  "Payment Comments",
  "Total Owing",
  "Decision",
  "Date Repaid",
  "Fee as at [Date]"
];
export const invoiceTableData = INVOICE_TABLE_COLUMNS.map((name, index) => ({
  id: index,
  name
}));
const INVOICE_TABLE_DOWNLOAD_DEFINITIONS = [
  ["Date", "invoiceDate"],
  ["Number", "invoiceNumber"],
  ["Due Date", "invoiceDueDate"],
  ["Total", "invoiceTotal"],
  ["Paid", "invoiceAmountPaid"],
  ["Paid Date", "invoiceFullyPaidDate"],
  ["Credited", "invoiceAmountCredited"],
  ["Due", "invoiceAmountDue"]
];
export const invoiceTableDataForDownload =
  INVOICE_TABLE_DOWNLOAD_DEFINITIONS.map(([name, value], index) => ({
    id: index,
    name,
    value
  }));
export const includedReportKeys = [
  "DISHONOURS - Direct Debit",
  "COMPLETED - Direct Debit",
  "SUBMITTED - Direct Debit",
  "PAID OUT - Direct Debit",
  "COMPLETED - Manual Payments",
  "PART PAID - Manual Payments"
];
const PAYMENT_REPORT_TYPES = [
  ["Current", "current"],
  ["Archive", "archive"]
];
export const paymentReportType = PAYMENT_REPORT_TYPES.map(
  ([name, value], index) => ({
    id: index + 1,
    name,
    value
  })
);
const INDUSTRY_VIEW_TYPES = [
  ["Month", "month"],
  ["Quarter", "quarter"],
  ["Year", "year"]
];
export const industryViewType = INDUSTRY_VIEW_TYPES.map(
  ([name, value], index) => ({
    id: index + 1,
    name,
    value
  })
);
const periodNums = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
export const timePeriods = periodNums.map((n) => ({
  id: n,
  name: String(n),
  value: String(n)
}));

const nums = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 24, 36, 48, 52];
export const allTimePeriods = nums.map((n) => ({
  id: n,
  name: String(n),
  value: String(n)
}));

const ALL_VIEW_TYPES = [
  ["Month", "Month"],
  ["Quarter", "Quarter"],
  ["Year", "Year"],
  ["Week", "Week"]
];

export const allViewType = ALL_VIEW_TYPES.map(([name, value], index) => ({
  id: index + 1,
  name,
  value
}));
const ALL_STATES_DEFINITIONS = [
  ["All", ""],
  ["(ACT)", "ACT"],
  ["New South Wales(NSW)", "NSW"],
  ["Northern Territory(NT)", "NT"],
  ["Queensland(QLD)", "QLD"],
  ["South Australia(SA)", "SA"],
  ["Tasmania(TAS)", "TAS"],
  ["Victoria(VIC)", "VIC"],
  ["Western Australia(WA)", "WA"]
];
export const allStatesData = ALL_STATES_DEFINITIONS.map(
  ([name, value], index) => ({
    id: index,
    name,
    value
  })
);
const KPI_FILTER_DEFINITIONS = [
  ["Type", "Type"],
  ["View", "View"],
  ["Period", "Period"],
  ["Filters", "Filters"],
  ["Status", "Status"],
  ["Generated on", "Generated on"],
  ["Action", "Action"]
];
export const kpiFilterData = KPI_FILTER_DEFINITIONS.map(
  ([name, value], index) => ({
    id: index,
    name,
    value
  })
);
const CUSTOMER_STATUS_DEFINITIONS = [
  ["All", "All"],
  [13, "Customer DD"],
  [2, "Approved"],
  [9, "Pre Approved"],
  [1, "Pending"],
  [3, "Not Approved"],
  [7, "Archived"],
  [12, "Test Account"]
];
export const customer_statusInv = CUSTOMER_STATUS_DEFINITIONS.map(
  ([id, name]) => ({
    id,
    name
  })
);
const customerStatusList = [
  ["--choose--", ""],
  ["Acc Soft. Connect/Disconnect", "account-software-connect/Disconnect"],
  ["Acc. Soft Consent", "account-software-concent"],
  ["Consents", "consents"],
  ["Acc. Soft Account Link", "Acc. Soft Account Link"],
  ["Acc. Soft Sync/API Pull", "account-software-sync-api-pull"],
  ["Identity/Credit Check Approval", "Identity/Credit-Check-Approval"],
  ["FundTap emails sent", "fundtap-email-sent"]
];
export const customer_status = customerStatusList.map(
  ([name, value], index) => ({
    id: String(index + 1),
    name,
    value
  })
);
export const Credit_DATA = [
  {
    id: "1",
    credit_score: "40",
    credit_risk: "20",
    adverse: "45",
    activity: "5",
    generated: "14-Feb-24"
  }
];
export const MOCK_DATA = [
  {
    id: "1",
    customers_name: "TOTAL",
    signed_up: "0",
    submitted: "0",
    funded: "0",
    funded_inv: "$0",
    completed: "$0",
    fees: "$0.00",
    upfront: "$0",
    trail: "$0.00"
  }
];

const REFERRAL_PARTNERS = ["MMCA", "Customer1", "Test Demo", "Test Demo AAC"];

const DEFAULT_REFERRAL_FIELDS = {
  signed_up: "0",
  submitted: "0",
  funded: "0",
  funded_inv: "$0",
  completed: "$0",
  fees: "$0.00",
  upfront: "$0",
  trail: "$0.00"
};
export const REFERRAL_MOCK_DATA = REFERRAL_PARTNERS.map(
  (referral_partner, index) => ({
    id: String(index + 1),
    referral_partner,
    ...DEFAULT_REFERRAL_FIELDS
  })
);
const TRACKING_DETAILS_VALUES = [
  ["FirstSource", "Marketing", "Facebook Posts", "17-Jan-2024"],
  ["FirstSource", "Marketing", "Google", "07-Apr-2024"]
];
export const TRACKING_DETAILS_DATA = TRACKING_DETAILS_VALUES.map(
  ([type, category, source, date], index) => ({
    id: String(index + 1),
    type,
    category,
    source,
    date
  })
);
export const TEMPLATE_PAYMENT_DATA = [
  {
    id: 0,
    text: "1. Call or email us (see contact details below)."
  },
  {
    id: 1,
    text: "2. Upload evidence you have contacted your customer to understand when they will pay you, e.g., a screenshot of an email with your customer."
  }
];
const COMPANY_NAME_VALUES = ["Company 1", "Company 2"];
export const COMPANY_NAME = COMPANY_NAME_VALUES.map((value, index) => ({
  id: index + 1,
  value
}));

export const AGREEMENT_TABLE_DATA = ["FILENAME", "DATE"].map((name, index) => ({
  id: index + 1,
  name
}));

const STATE_DATA = ["NSW", "QLD", "WA", "SA", "NT", "ACT", "TAS", "VIC"];
export const state_name_value = STATE_DATA.map((item, index) => ({
  id: index + 1,
  name: item,
  value: item
}));

const COMPANY_ITEMS = [
  BUSINESS_TYPE_NOT_SURE,
  BUSINESS_TYPE_LIMITED_COMPANY,
  BUSINESS_TYPE_SOLE_TRADER,
  BUSINESS_TYPE_PARTNERSHIP,
  BUSINESS_TYPE_LIMITED_LIABILITY_PARTNERSHIP,
  BUSINESS_TYPE_TRADING_TRUST
];
export const CompanyItemsData = COMPANY_ITEMS.map((company, index) => ({
  id: index + 1,
  company
}));

const SHAREHOLDER_ITEMS = [
  ["Select", ""],
  ["Personally held", PERSONALLY_HELD],
  ["Held by a Trust", TRUST_HELD],
  ["Held by a company", COMPANY_HELD]
];

export const shareholder_items = SHAREHOLDER_ITEMS.map(
  ([name, value], index) => ({
    id: String(index + 1),
    name,
    value
  })
);

const TRUSTEE_TYPE_ITEMS = [
  ["Individual", "individual"],
  ["Company", "company"]
];

export const trustee_type_items = TRUSTEE_TYPE_ITEMS.map(
  ([name, value], index) => ({
    id: String(index + 1),
    name,
    value
  })
);

const PROPERTY_OWNED_ITEMS = [
  ["Personally owned", "Personally Owned"],
  ["Owned by a trust", "Owned by a Trust"],
  ["Owned by a company", "Owned by a Company"]
];

export const property_owned_items = PROPERTY_OWNED_ITEMS.map(
  ([name, value], index) => ({
    id: String(index + 1),
    name,
    value
  })
);

const bankNameList = [
  ["Select your bank", ""],
  ["ANZ", "ANZ"],
  ["Westpac", "Westpac"],
  ["BNZ", "BNZ"],
  ["ASB", "ASB"],
  ["Kiwibank", "Kiwibank"],
  ["Other", "Other"]
];
export const customer_Bank_Name = bankNameList.map(([name, value], index) => ({
  id: String(index + 1),
  name,
  value
}));

const auBankNameList = [
  ["Select your bank", ""],
  ["CBA", "CBA"],
  ["Westpac Banking Corporation", "WESTPAC_BANKING_CORPORATION"],
  ["NAB", "NAB"],
  ["ANZ", "ANZ"],
  ["Macquarie", "MACQUARIE"],
  ["Bendigo and Adelaide Bank", "BENDIGO_AND_ADELAIDE_BANK"],
  ["BOQ", "BOQ"],
  ["ING Australia", "ING_AUSTRALIA"],
  ["AMP Bank", "AMP_BANK"],
  ["Suncorp Bank", "SUNCORP_BANK"],
  ["Revolut", "REVOLUT"],
  ["Other", "Other"]
];

export const customer_Au_Bank_Name = auBankNameList.map(
  ([name, value], index) => ({
    id: String(index + 1),
    name,
    value
  })
);

export const facilitySizeMap = {
  BELOW_30: "below-30",
  BETWEEN_30_100: "30-100",
  BETWEEN_100_250: "100-250",
  ABOVE_250: "above-250"
};
